module.exports = __webpack_public_path__ + "img/home-im.3fabbabd.png";